import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { APP } from '@/constants/testIds';
import { Sprout, CalendarClock, CloudSun, Droplets, Leaf, TrendingUp, Scissors, IndianRupee, BarChart3, Landmark, Sparkles } from 'lucide-react';

import ActionPlan from '@/components/advisory/ActionPlan';
import Suitability from '@/components/advisory/Suitability';
import Sowing from '@/components/advisory/Sowing';
import Weather from '@/components/advisory/Weather';
import Irrigation from '@/components/advisory/Irrigation';
import Nutrient from '@/components/advisory/Nutrient';
import Growth from '@/components/advisory/Growth';
import Harvest from '@/components/advisory/Harvest';
import Market from '@/components/advisory/Market';
import Analytics from '@/components/advisory/Analytics';
import Schemes from '@/components/advisory/Schemes';

const TABS = [
  { id: 'plan', label: 'Action Plan', Icon: Sparkles, testId: APP.tabs.plan, Cmp: ActionPlan },
  { id: 'suitability', label: 'Crop Selection', Icon: Sprout, testId: APP.tabs.suitability, Cmp: Suitability },
  { id: 'sowing', label: 'Sowing Advisory', Icon: CalendarClock, testId: APP.tabs.sowing, Cmp: Sowing },
  { id: 'weather', label: 'Weather & Alerts', Icon: CloudSun, testId: APP.tabs.weather, Cmp: Weather },
  { id: 'irrigation', label: 'Irrigation', Icon: Droplets, testId: APP.tabs.irrigation, Cmp: Irrigation },
  { id: 'nutrient', label: 'Nutrient', Icon: Leaf, testId: APP.tabs.nutrient, Cmp: Nutrient },
  { id: 'growth', label: 'Growth', Icon: TrendingUp, testId: APP.tabs.growth, Cmp: Growth },
  { id: 'harvest', label: 'Harvest', Icon: Scissors, testId: APP.tabs.harvest, Cmp: Harvest },
  { id: 'market', label: 'Market Advisory', Icon: IndianRupee, testId: APP.tabs.market, Cmp: Market },
  { id: 'schemes', label: 'Govt Schemes', Icon: Landmark, testId: APP.tabs.schemes, Cmp: Schemes },
  { id: 'analytics', label: 'Analytics', Icon: BarChart3, testId: APP.tabs.analytics, Cmp: Analytics },
];

const Dashboard = (props) => (
  <div className="animate-fade-up">
    <Tabs defaultValue="plan" className="w-full">
      <TabsList data-testid={APP.tabsList} className="w-full h-auto bg-white border border-border/60 p-1 mb-6 rounded-xl overflow-x-auto flex flex-nowrap sm:flex-wrap gap-1 justify-start sm:justify-center">
        {TABS.map(({ id, label, Icon, testId }) => (
          <TabsTrigger
            key={id}
            value={id}
            data-testid={testId}
            className="shrink-0 sm:flex-1 min-w-[110px] gap-2 data-[state=active]:!bg-icrisat-green data-[state=active]:!text-white text-icrisat-earth py-2"
          >
            <Icon className="h-4 w-4" />
            <span className="text-xs sm:text-sm whitespace-nowrap">{label}</span>
          </TabsTrigger>
        ))}
      </TabsList>
      {TABS.map(({ id, Cmp }) => (
        <TabsContent key={id} value={id} className="space-y-4">
          <Cmp {...props} />
        </TabsContent>
      ))}
    </Tabs>
  </div>
);

export default Dashboard;
